import React from 'react';
import { X } from 'lucide-react';

const TAG_COLORS: Record<string, string> = {
  gold: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  red: 'bg-red-100 text-red-800 border-red-300',
  orange: 'bg-orange-100 text-orange-800 border-orange-300',
  purple: 'bg-purple-100 text-purple-800 border-purple-300',
  blue: 'bg-blue-100 text-blue-800 border-blue-300',
  green: 'bg-green-100 text-green-800 border-green-300',
  gray: 'bg-gray-100 text-gray-800 border-gray-300',
};

interface TagChipProps {
  tag: { id?: number; name: string; color?: string; is_system?: boolean };
  size?: 'sm' | 'md';
  onRemove?: () => void;
}

export const TagChip: React.FC<TagChipProps> = ({ tag, size = 'md', onRemove }) => {
  const colorClass = TAG_COLORS[tag.color || 'gray'] || TAG_COLORS.gray;
  const sizeClass = size === 'sm'
    ? 'text-[10px] px-1.5 py-0.5 gap-0.5'
    : 'text-xs px-2 py-1 gap-1';

  return (
    <span className={`inline-flex items-center rounded-full border font-medium ${colorClass} ${sizeClass}`}>
      {tag.name}
      {onRemove && (
        <button
          onClick={(e) => { e.stopPropagation(); onRemove(); }}
          className="hover:opacity-70 transition-opacity"
        >
          <X size={size === 'sm' ? 10 : 12} />
        </button>
      )}
    </span>
  );
};
